import { TreeSelect } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { Translate } from '@above-the-treeline/localization';
import useCategoryFilters from '../../hooks/useCategoryFilters';
import BrowseLaneType from '../../SavedFilters/Administer/BrowseLaneType';
import { useSavedFilter } from '../../SavedFilters/containers/SavedFilterDataStore';
import SavedFilterTypes from '../../SavedFilters/SavedFilterTypes';
import { LoadingSpinnerSize } from '../../UI/LoadingSpinner';
import LoadingSpinnerInContainer from '../../UI/LoadingSpinnerInContainer';
import { useSavedCommunityFilters } from '../containers/SavedCommunityFiltersDataStore';
import SaveAndCancelButtons from '../UI/SaveAndCancelButtons/SaveAndCancelButtons';
import { replaceExclusion, setSavedFilters } from '../util';
import ActiveFilters from './ActiveFilters';

AddEditCategoryFilters.propTypes = {
	browseRefinements: PropTypes.array,
	leaveEditMode: PropTypes.func,
	savedFilterType: PropTypes.string,
};

export default function AddEditCategoryFilters({
	browseRefinements,
	leaveEditMode,
	savedFilterType,
}) {
	const [activeCategories, setActiveCategories] = React.useState([]);
	const [value, setValue] = React.useState(null);
	const { categoryFilters, isLoading } = useCategoryFilters();

	const savedFilterDataStore = useSavedFilter();

	const savedCommunityFiltersDataStore = useSavedCommunityFilters();

	React.useEffect(() => {
		const allSavedFilters = setSavedFilters(browseRefinements);
		setActiveCategories(allSavedFilters);
	}, []);

	const saveFilters = () => {
		switch (savedFilterType) {
			case SavedFilterTypes.group:
				savedCommunityFiltersDataStore.saveFilters(
					activeCategories,
					BrowseLaneType.Category,
				);
				break;
			case SavedFilterTypes.user:
				savedFilterDataStore.saveFilters(
					activeCategories,
					BrowseLaneType.Category,
				);
				break;
		}
		leaveEditMode();
	};

	const onChange = value => {
		setValue(value);
		setActiveCategories([...activeCategories, value]);
	};

	const removeFilter = value => {
		var newActiveCategories = activeCategories.filter(
			sec => sec.value !== value,
		);
		setActiveCategories(newActiveCategories);
	};

	const changeExclusion = value => {
		const newActiveCategories = replaceExclusion(activeCategories, value);
		setActiveCategories(newActiveCategories);
	};

	return !isLoading ? (
		<div className="add-edit-category-filters">
			<TreeSelect
				labelInValue
				style={{ width: '100%' }}
				value={value}
				dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
				treeData={categoryFilters}
				placeholder={<Translate id="please_select" />}
				treeDataSimpleMode
				onChange={onChange}
			/>
			<ActiveFilters
				activeCategories={activeCategories}
				removeFilter={removeFilter}
				changeExclusion={changeExclusion}
			/>
			<SaveAndCancelButtons
				onSave={saveFilters}
				onCancel={leaveEditMode}
			/>
		</div>
	) : (
		<LoadingSpinnerInContainer size={LoadingSpinnerSize.small} />
	);
}
